import React, { useState } from 'react'
import './ViewCallDetailsStyle.css'
// import CallRecordpopup from '../../CallRecordpopup/CallRecordpopup'
import Progressbar from '../../ProgressBar/Progressbar';
import { useNavigate } from 'react-router-dom';
import Button from '../../Button/Button';
import moment from 'moment';

const MeViewCallds = ({ isActive, menteeFeedback, mentorFeedback, callInfo, handleClose }) => {

    const navigate = useNavigate();
    return (
        <div className={`popupWrapper poupviewtab  ${isActive && "active"}`}>
            <div className={`popupContainer poupCDcontainer`}>
                <div className="popupBody DscallAdbody">
                    <span className="closebtn mb10">
                        <img src="/assets/svg/close.svg" alt="" onClick={handleClose} />
                    </span>
                    <div className="headingpoup">
                        <h3>Call Details</h3>
                    </div>

                    <div className=" Adwrapperdetails">
                        <div className="HeaderCallDetailsFaq">
                            <p className='text2'>
                                Agenda:
                                <span className='boldtext ml4'>{callInfo?.agenda ? callInfo?.agenda : "---"}</span>
                            </p>
                        </div>
                        <div className='AgendapopupCallhistory'>
                            <div className='AnswerFaq  AnsForNewFaqUsers'>
                                <div className="answerFaqnew dataVwbackmain">
                                    <ul>
                                        <li>
                                            <div className="profileHistoryDeatils f-items-center">
                                                <div className="userpopupimg">
                                                    <img src={callInfo?.mentor?.profileImg ? callInfo?.mentor?.profileImg : "/assets/img/User.png"} alt='' onClick={() => { navigate(`/mentee/mentor-profile/${callInfo?.mentor?.id}`) }} />
                                                </div>
                                                <div className="CallDetailsNameData flex">
                                                    <div className="NameDetails">
                                                        <h3 className='namelink pointer' onClick={() => { navigate(`/mentee/mentor-profile/${callInfo?.mentor?.id}`) }}>{callInfo?.mentor?.firstName ? `${callInfo?.mentor?.firstName} ${callInfo?.mentor?.lastName}` : "---"}</h3>
                                                        <p className="text2 capitilize">{callInfo?.mentor?.profession?.designation ? callInfo?.mentor?.profession?.designation : "---"}</p>
                                                    </div>
                                                    <span className='Mentorspan Designspan'> Mentor</span>
                                                </div>
                                            </div>
                                        </li>

                                    </ul>
                                    <ul className='listVWlistdata listitemscdmaindiv'>
                                        <li> <span>Date: </span>{callInfo?.startTime ? moment(callInfo?.startTime).utcOffset("-00:00").format("DD MMMM, YYYY") : "---"}</li>
                                        {(callInfo?.meetingStatus === "cancelled" || callInfo?.meetingStatus === "reschedule") && 
                                        <>
                                        <li><span>Reason: </span>{callInfo?.cancelReason}</li>
                                        <li><span className='capitilize'>{callInfo?.meetingStatus} by: </span>{callInfo?.cancelledBy === "Mentee" ? "Self" : callInfo?.cancelledBy}</li>
                                        </>
                                        }
                                        {callInfo?.meetingStatus === "completed" && <>
                                        <li> <span>Call Duration: </span>{callInfo?.callDuration ? (callInfo?.callDuration / 60).toFixed(0) + " min" : "---" }</li>
                                        <li> <span>Call Start time: </span>{callInfo?.startedAt ? moment(callInfo?.startedAt).format("hh:mm a") : "---"}</li>
                                        <li> <span>Call End time: </span>{callInfo?.endedAt ? moment(callInfo?.endedAt).format("hh:mm a") : "---"}</li>
                                        <li> <span>Call Started by:</span>{callInfo?.startedBy ? callInfo?.startedBy : "---"}</li>
                                        <li> <span>Call Ended by: </span>{callInfo?.endedBy ? callInfo?.endedBy : "---"}</li>
                                        </>}
                                        {callInfo?.meetingStatus === "pending" && 
                                            <li><span className='capitilize'>Mentor: </span>{callInfo?.isMentorJoined ? "Joined": "No Show"}</li>
                                        }
                                        <li className='flex'> <span>Status:</span>
                                            <p className={`conptext ${callInfo?.meetingStatus === "pending" ? 'noshow' : callInfo?.meetingStatus} capitilize ml4`}>{callInfo?.meetingStatus ? callInfo?.meetingStatus === "pending" ? 'No Show' : callInfo?.meetingStatus : "---"}</p>
                                        </li>
                                    </ul>
                                </div>

                            {callInfo?.meetingStatus === "completed" && <>
                                <div className="dottedbr mb-20"></div>
                                <div className='mntorsFeedbackdata'>
                                    <h3 className='heading-3'>Feedback Given</h3>

                                    <div className={`Fbackactivetab mt-10`}>
                                    {menteeFeedback && Object?.keys(menteeFeedback).length > 0 ? <div className={`ProgressQuestionCallhistory`}>
                                    <div className="QuestionProgressbarPop">
                                        <h3>Was the call helpful for you ?</h3>
                                        <p className="text2 capitilize">{menteeFeedback?.answer1 ? menteeFeedback?.answer1 : "---"}</p>
                                    </div>

                                    <div className="QuestionProgressbarPop">
                                        <h3>Would you like to schedule a call again with the same Mentor?</h3>
                                        <p className="text2 capitilize">{menteeFeedback?.answer2 ? menteeFeedback?.answer2 : "---"}</p>
                                    </div>
                                    <div className="QuestionProgressbarPop">
                                        <h3>Was the Mentor able to answer your questions?</h3>
                                        <p className="text2 capitilize">{menteeFeedback?.answer3 ? menteeFeedback?.answer3 : "---"}</p>
                                    </div>
                                    <div className="QuestionProgressbarPop">
                                        <h3>Rate your experience with the Mentor?</h3>
                                        <Progressbar count={menteeFeedback?.answer4 ?? 0} />
                                    </div>
                                        </div> : "No Feedback given"}
                                    </div>
                                </div>

                            </>}
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default MeViewCallds